import useLockedBody from './use-locked-body';

export { useLockedBody };

export default useLockedBody;
